import { useRef, useState } from "react";
import { useAsyncAction } from "../../hooks/useAsyncAction";

type Action = "save" | "authorize";

/** Serialize form submissions and reconnects, preserving pending through OAuth navigation. */
export function useConnectionAction() {
  const action = useAsyncAction();
  const [active, setActive] = useState<Action | null>(null);
  const [redirecting, setRedirecting] = useState(false);
  const redirectStarted = useRef(false);

  const run = (kind: Action, operation: () => Promise<void>) => {
    if (redirectStarted.current) return Promise.resolve();
    return action.run(async () => {
      setActive(kind);
      try { await operation(); }
      finally { if (!redirectStarted.current) setActive(null); }
    });
  };
  const redirect = (url: string) => {
    window.location.assign(url);
    redirectStarted.current = true;
    setRedirecting(true);
  };
  const pending = action.pending || redirecting;
  return { run, redirect, pending, saving: pending && active === "save", authorizing: pending && active === "authorize" };
}
